module.exports = __webpack_public_path__ + "assets/numbered-list.467bb10a.svg";